<div class="w-full custom-form flex items-center">
  @if (!loading()) {
    <mat-form-field class="w-full mat-select-slim">
      <mat-select
        multiple
        [value]="selectionState().uiSelectedValues"
        [hideSingleSelectionIndicator]="true"
        [placeholder]="emptyLabel()"
        (openedChange)="onOpenedChange($event)"
        (closed)="onPanelClosed()"
        (selectionChange)="onSelectionChange($event)"
      >
        <mat-select-trigger>
          <span>{{ triggerLabel() }}</span>
        </mat-select-trigger>

        <div class="flex items-center" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
          <button
            mat-flat-button
            color="secondary-transparent"
            class="mat-slim-button"
            type="button"
            (click)="onSelectAll($event)"
          >
            {{ 'shared.selectAll' | translate }}
          </button>
          <button
            mat-flat-button
            color="secondary-transparent"
            class="mat-slim-button"
            type="button"
            (click)="onUnselectAll($event)"
          >
            {{ 'shared.unselectAll' | translate }}
          </button>
        </div>

        @for (creator of creatorOptions(); track creator.id) {
          <mat-option [value]="creator.id">
            <div class="flex items-center gap-2 min-w-0">
              <app-icon-badge
                [content]="creator.icon"
                [fallbackText]="creator.name"
                [size]="24"
                [iconSize]="24"
                [fontSize]="14"
              />
              <span class="truncate">{{ creator.name }}</span>
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <ngx-skeleton-loader class="h-[34px]" [theme]="{ height: '34px', width: '252px', 'border-radius': '100vw' }" />
  }
</div>
